import type { SVGProps } from 'react';
const SvgHd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#hd_svg__a)">
      <path
        fill="currentColor"
        d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6Zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9Zm1.5 4.5h2v-3h-2v3Z"
      />
    </g>
    <defs>
      <clipPath id="hd_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHd;
